import script from "./BetSlip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BetSlip.vue?vue&type=script&setup=true&lang=ts"

import "./BetSlip.vue?vue&type=style&index=0&id=6542ab9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6542ab9f"]])

export default __exports__